function greaterEqual(a, b) {
  return a >= b;
}

greaterEqual.op = '>=';

export default greaterEqual;
